import { injectable } from 'inversify';

import { RootState, useAppSelector } from '../../../../state/hooks';
import { store } from '../../../../state/store';
import { AssessmentQueryParamService } from '../assessment.queryParam.service';
import assessmentSpecifications from './md_portal_clearance_screen.json';
import { ModulesSpecsDomain } from './modules/modules.domain';
import {
  StepperDispatchers,
  StepperSelectors,
} from './takeAssessmentStepper.slice';
import { AssessmentModules } from './modules';
import { StepperService } from '../../../../components/stepper/stepper.service';

@injectable()
export class TakeAssessmentDomain extends StepperService {
  // TODO: Move these states to a data service, either view or queryparams data service
  private inputIsValid: boolean;
  shouldShowValidationWarning: boolean;

  private showValidationWarningCallback: (value: boolean) => void;

  constructor(
    private assessmentQueryParamService: AssessmentQueryParamService,
    private moduleSpecsDomain: ModulesSpecsDomain,
  ) {
    super(StepperDispatchers, StepperSelectors);
    this.inputIsValid = false;
    this.shouldShowValidationWarning = false;
    this.showValidationWarningCallback = (value: boolean) => {};
  }

  setShowValidationWarningCallback = (cb: (value: boolean) => void) => {
    this.showValidationWarningCallback = cb;
  };

  setShowValidationWarning = (value: boolean) => {
    this.shouldShowValidationWarning = value;
    this.showValidationWarningCallback(value);
  };

  isLastAssessmentScreen = (): boolean => {
    const queryParam =
      this.assessmentQueryParamService.assessmentPageQuerySelector(
        store.getState(),
      );

    return (
      assessmentSpecifications.manifest.assessmentModules.length ===
      queryParam?.activeStep
    );
  };

  dispatchActiveStep = () => {
    const queryParam =
      this.assessmentQueryParamService.assessmentPageQuerySelector(
        store.getState(),
      );

    if (queryParam?.activeStep) {
      store.dispatch(StepperDispatchers.setActiveStep(queryParam.activeStep));
    }
  };

  useModuleSelector = (): string => {
    // TODO : This is an example how it should work
    // return useAppSelector(selectActiveStep).map((activeStep: number) => {
    //   return assessmentSpecifications.manifest.assessmentModules[activeStep - 1].name;
    // });

    // TODO : See if there is a better way and not leak the reducer
    return useAppSelector((state: RootState) => {
      // eslint-disable-next-line prefer-destructuring
      const activeStep = state.takeAssessmentStepperReducer.activeStep;
      return assessmentSpecifications.manifest.assessmentModules[activeStep - 1]
        .name;
    });
  };

  dispatchNextEnabledAndValidate(
    module: any,
    assessmentModule: AssessmentModules,
    timerStarted?: boolean,
    selectedMonths?: string[],
  ): void {
    store.dispatch(StepperDispatchers.setNextEnabled(true));

    this.inputIsValid = this.moduleSpecsDomain.validateModule(
      module,
      assessmentModule,
      timerStarted,
      selectedMonths,
    );

    if (this.inputIsValid) {
      this.setShowValidationWarning(false);
    }
  }

  totalAssessmentSteps = (): number => {
    return assessmentSpecifications.manifest.assessmentModules.length + 1;
  };

  assessmentTypeSpecs = (): any => {
    return {
      assessmentSpecifications,
    };
  };

  selectActiveStep = (state: RootState): number => {
    return state.takeAssessmentStepperReducer.activeStep;
  };

  dispatchIncrementActiveStep(): void {
    if (this.inputIsValid) {
      this.setShowValidationWarning(false);
      const activeStep: number = this.selectActiveStep(store.getState());
      this.assessmentQueryParamService.dispatchQueryParams({
        activeStep: activeStep + 1,
      });
      super.dispatchIncrementActiveStep();
    } else {
      this.setShowValidationWarning(true);
    }
  }

  dispatchDecrementActiveStep(): void {
    const activeStep = this.selectActiveStep(store.getState());
    this.assessmentQueryParamService.dispatchQueryParams({
      activeStep: activeStep - 1,
    });
    super.dispatchDecrementActiveStep();
  }

  dispatchResetStepper(): void {
    super.dispatchResetStepper();
  }
}
